import React from 'react';
import styled from 'styled-components';

type Variant = 'primary' | 'secondary' | 'inverse';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export const Button = ({
  children,
  variant = 'primary',
  ...props
}: React.PropsWithChildren<ButtonProps>) => (
  <Btn variant={variant} {...props}>
    {children}
  </Btn>
);

const variantOptions = {
  backgroundColor: {
    primary: `#f79422;`,
    secondary: ` #152e63;`,
    inverse: ` #fff;`,
  },
  fontWeight: {
    primary: 700,
    secondary: 700,
    inverse: 400,
  },
};

const Btn = styled.button<{ variant: Variant }>`
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => variantOptions.fontWeight[props.variant]};
  color: ${(props) =>
    props.variant === 'inverse'
      ? props.theme.color.text.primary
      : props.theme.color.text.inverse};
  background-color: ${(props) => variantOptions.backgroundColor[props.variant]};
  border-radius: 3px;
  border-color: ${(props) => props.theme.color.ui.shade2};
  border-style: solid;
  border-width: ${(props) => (props.variant === 'inverse' ? '1px' : 0)};
  display: flex;
  height: 38px;
  padding: 0px 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  transition: 0.8s;
  :hover {
    filter: brightness(0.95);
  }

  :disabled {
    opacity: 0.5;
  }

  svg {
    font-size: 16px;
  }

  .btn-inverse {
    color: ${(props) => props.theme.color.bg.primary};
  }
`;
